/* istanbul ignore file */
import { notifyErrors } from 'shared/helpers/logger';
import createApp from './app';

const { Vue, Vuex } = window;

Vue.config.errorHandler = e => {
  notifyErrors('SMAUG_SEO_DESKTOP', e);
};

const data = global.SeoDesktop || {};
const { app, router } = createApp({ Vue, Vuex, data, isSSR: false });

router.onReady(() => {
  app.$mount('#app', true);
});
